<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: 'app',
    mounted () {
      scaleHeaderTitle();
      $(window).resize(function () {
        scaleHeaderTitle();
      });
    },
    head: {
      meta: function() {
        return [
          { he: 'content-language', content: this.$i18n.locale }
        ]}
    }
  }

  function scaleHeaderTitle() {
    var $headerPar = $('.mt-page-nav-image p');
    var $headerTitle = $('.mt-page-nav-image p span');
    var classIndex = 1;
    if ($headerTitle.length > 0) {
      while ($headerTitle[0].getClientRects().length > 1 && classIndex < 5) {
        $headerPar.removeClass('par-text-'.concat(classIndex++));
        $headerPar.addClass('par-text-'.concat(classIndex));
      }
      $headerPar.css('opacity', '0.5');
    }
  }
</script>

<style>

  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700,800,900');

  @font-face {
    font-display: auto;
  }

  /* ------------------ START - global ------------------ */
  html {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    width: 100%;
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
    position: relative;
    overflow-y: scroll;
    background-color: #fff;
  }

  a {
    color: #0071b3;
  }

  a:hover,
  a:focus,
  .link:hover,
  .link:focus {
    color: #018fe2;
  }

  a:active,
  .link:active {
    color: #23aeff;
  }
  /* ------------------ END - global ------------------ */

  /* ------------------ START - lazy loading images ------------------ */
  img:not(.initial) {
    transition: opacity 0.5s;
  }
  img.initial,
  img.loaded,
  img.error {
    opacity: 1;
  }

  img:not([src]) {
    visibility: hidden;
  }
  /* ------------------ END - lazy loading images ------------------ */

  /* ------------------ START - commons ------------------ */
  .container-fluid {
    margin: 0;
    padding: 0;
  }
  /* ------------------ END - commons ------------------ */

  /* ------------------ START - consts ------------------ */
  .mt-c-blue-light {
    color: #4092e5;
  }

  .mt-c-blue-regular {
    color: #295d92;
  }

  .mt-c-red {
    color: red;
  }

  .mt-c-white {
    color: #fff;
  }

  .mt-c-grey {
    color: #6c6c6c;
  }

  .mt-c-grey-light {
    color: #a1a1a1;
  }

  .mt-p-fs-x-large {
    font-size: xx-large;
  }

  .mt-fs-x-large {
    font-size: x-large;
    line-height: 0;
    vertical-align: middle;
  }

  .mt-fs-large {
      font-size: large;
      line-height: 0;
      vertical-align: middle;
  }

  .mt-fs-x-small {
    font-size: x-small;
  }

  .mt-fs-small {
      font-size: small;
  }

  .mt-fs-32 {
    font-size: 32pt;
  }

  .mt-fs-14 {
    font-size: 14pt;
  }

  .mt-eight::before {
    content: '\0038';
    margin: 0;
    padding: 0;
  }

  .mt-zero::before {
    content: '\0030';
    margin: 0;
    padding: 0;
  }

  .mt-space::before {
    content: '\0020';
    margin: 0;
    padding: 0;
  }

  .mt-at::before {
    content: '\0040';
    margin: 0;
    padding: 0;
  }

  .mt-enum::before {
    content: '\2022';
    margin: 0;
    padding: 0;
  }

  .mt-enum::after {
    content: '\0020';
    margin: 0;
    padding: 0;
  }

  .mt-f-light {
    font-weight: 300;
  }

  .mt-f-regular {
    font-weight: 500;
  }

  .mt-f-bold {
    font-weight: 700;
  }

  .mt-f-extra-bold {
    font-weight: 800;
  }

  .mt-f-black {
    font-weight: 900;
  }

  @media (max-width: 1200px) {
    .mt-lg-only {
      display: none;
    }
  }

  @media (max-width: 992px) {
    .mt-md-only {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .mt-sm-only {
      display: none;
    }
  }

  @media (min-width: 768px) {
    .mt-to-sm-only {
      display: none;
    }
  }

  @media (min-width: 992px) {
    .mt-to-md-only {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .mt-xs-h1-f-size {
      font-size: x-large;
    }
  }

  @media (min-width: 768px) {
    .mt-vspace-1 {
      height: 180px;
    }
  }
  /* ------------------ END - consts ------------------ */

  /* ------------------ START - links and buttons ------------------ */
  .btn-primary {
    background-color: #007bff;
    border-color: #007bff;
  }

  .btn-primary:hover,
  .btn-primary:focus {
    background-color: #0256b1;
  }

  .icon-link {
    width: 40px;
    height: 40px;
    background-color: #fff;
    line-height: 40px;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    cursor: pointer;
    outline: none;
    margin: 5px;
    box-sizing: content-box;
    border: 1px solid #295d92;
  }

  .icon-link.fill.facebook {
    background-color: #3b5998;
  }

  .icon-link.fill.facebook:hover {
    background-color: #fff;
  }

  .icon-link.fill.facebook:hover .fa-facebook {
    color: #3b5998;
    transition: color 150ms ease-in-out;
  }

  .icon-link.brand {
    background-color: #fff;
  }

  .icon-link.brand .fa {
    color: #006FC2;
  }

  .icon-link:hover {
    transition: background-color 150ms ease-in-out;
    background-color: #fff;
  }

  .icon-link:hover.facebook {
    border: 1px solid;
  }

  .icon-link:hover .fa-facebook {
    color: #3b5998;
    transition: color 150ms ease-in-out;
  }

  .icon-link .fa {
    color: #fff;
    line-height: 40px;
    font-size: 24px;
  }

  .mt-button {
    border-radius: 0;
    border: 0;
    padding: .7rem 1.5rem;
    font-size: .9rem;
  }

  .mt-button.mt-button-primary, .product-var button {
    background-color: #4092e5;
    color: #fff;
  }

  .mt-button.mt-button:hover, .product-var button:hover {
    background-color: #295d92;
    color: #fff;
  }

  .mt-button.mt-button-secondary {
    background-color: #fff;
    color: #000;
    border: solid 1px #4092e5;
    border-radius: 0;
  }

  .mt-button.mt-button-secondary:hover {
    background-color: #e5f3ff;
    color: #000;
  }

  .mt-btn-labeled {
    padding-left: 0;
  }

  .mt-button-fix-width {
    width: 150px;
  }

  .mt-button-border {
    border: solid 1px #4092e5;
  }
  /* ------------------ END - links and buttons ------------------ */

  /* ------------------ START - page specific ------------------ */
  .square {
    padding-bottom: 100%;
  }

  .jumbotron{
    margin-bottom: 0;
    border-radius: 0;
    padding-bottom: 0;
    padding-top: 0;
  }

  .mt-page-nav-image {
    min-height: 200px;
    background-size: cover;
    background-position: 50% 50%;
    opacity: 0.75;
    filter: alpha(opacity=75);
    z-index: 1;
  }

  .mt-page-nav-image p, .mt-page-nav-image h1 {
    color: #000;
    opacity: 0;
    line-height: 0;
    text-align: right;
  }

  @media (min-width: 992px) {
    .mt-page-nav-image p.par-text-1, .mt-page-nav-image h1.par-text-1 {
      padding-top: 165px;
    }

    .mt-page-nav-image p.par-text-2, .mt-page-nav-image h1.par-text-2 {
      font-size: 5rem;
      padding-top: 171px;
    }

    .mt-page-nav-image p.par-text-3, .mt-page-nav-image h1.par-text-3 {
      font-size: 4rem;
      padding-top: 176px;
    }

    .mt-page-nav-image p.par-text-4, .mt-page-nav-image h1.par-text-4 {
      font-size: 3rem;
      padding-top: 183px;
    }
  }

  @media (max-width: 992px) {
    .jumbotron p, .jumbotron h1, .mt-page-nav-image p, .mt-page-nav-image h1 {
      font-size: 2rem;
      padding-top: 189px !important;
      opacity: 0.80 !important;
      white-space: nowrap;
    }
  }

  .mt-faq-container span {
    line-height: 0;
    vertical-align: middle;
  }

  .mt-faq-container>div:last-child {
    margin-bottom: 25px;
  }

  @media (min-width: 992px) {
    .mt-faq-container:last-child {
      background-repeat: no-repeat;
      background-position: bottom right;
      background-position-x: 97%;
      padding-bottom: 25px;
    }
  }

  @media (max-width: 992px) {
    .mt-faq-container {
      background-image: none !important;
    }
  }

  .mt-faq-a {
    background-color: #fff;
  }

  .mt-faq-a span.faq-letter {
    padding-left: 14px;
  }

  .mt-faq-q .faq-letter, .mt-faq-a .faq-letter {
    font-size: 2.6rem;
  }

  .mt-contact-section, .mt-subpage-section {
    background-image: linear-gradient(to right, #295d92 , #122840);
  }

  .mt-contact-section > .container-fluid {
    background-repeat: no-repeat;
    background-position: center -250px;
  }

  .mt-subpage-section > .container-fluid {
      background-image: linear-gradient(to top, transparent 0%, transparent 330px, #91A7BD 330px, #91A7BD 336px, #C9D3DE 336px, #C9D3DE 342px, white 342px,  white 100%);
  }

  @media (max-width: 768px) {
      .mt-subpage-section > .container-fluid {
          background-image: linear-gradient(to top, transparent 0%, transparent 730px, #91A7BD 730px, #91A7BD 736px, #C9D3DE 736px, #C9D3DE 742px, white 742px,  white 100%);
      }
  }

  .mt-subpage-section > .container-fluid > .container-fluid{
    background-repeat: no-repeat;
    background-position: center bottom;
  }

  @media (max-width: 992px) {
    .mt-subpage-section > .container-fluid > .container-fluid{
      background-position-y: calc(100% - 300px);
    }
  }

  .content-container {
    min-height: 400px;
    margin-bottom: 400px;
  }

  @media (max-width: 992px) {
    .content-container {
      margin-bottom: 200px;
    }
  }
  /* ------------------ END - page specific ------------------ */

  /* ------------------ START - Google Map ------------------ */
  .gm-style {
    font: inherit !important;
  }

  .gm-style .gm-style-iw {
    font-size: inherit !important;
  }
  /* ------------------ END - Google Map ------------------ */

  /* ------------------ START - forms ------------------ */
  .form input, .form textarea {
    outline: 0;
    background: #fafafa;
    width: 100%;
    border: solid 1px #4092e5;
    border-radius: 0;
    margin: 0 0 25px;
    padding: 25px;
    box-sizing: border-box;
    font-size: 14px;
  }

  .form textarea:focus {
    box-shadow: none;
    background-color: #fafafa;
  }

  .mt-q-input input[type="number"] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }

  .mt-q-input input[type=number]::-webkit-inner-spin-button,
  .mt-q-input input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  .mt-q-input .number-input {
    border: none;
    display: inline-flex;
  }

  .mt-q-input .number-input,
  .mt-q-input .number-input * {
    box-sizing: border-box;
  }

  .mt-q-input .number-input button {
    outline:none;
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    margin: 0;
    position: relative;
  }

  .mt-q-input .number-input button:before,
  .mt-q-input .number-input button:after {
    display: inline-block;
    position: absolute;
    content: '';
    width: 0.75rem;
    height: 2px;
    background-color: #122840;
    transform: translate(-50%, -50%);
  }
  .mt-q-input .number-input button.plus:after {
    transform: translate(-50%, -50%) rotate(90deg);
  }

  .mt-q-input .number-input input[type=number] {
    background-color: #fafafa;
    max-width: 5rem;
    padding: 0;
    border: none;
    height: 2rem;
    text-align: center;
  }

  .mt-checkout .js-form-type-textfield {
    display: inline-block;
  }

  @media (min-width: 992px) {
    .mt-checkout .js-form-type-textfield.form-name,
    .mt-checkout .js-form-type-textfield.form-last-name {
      width: 50%;
    }

    .mt-checkout .js-form-type-textfield.form-phone,
    .mt-checkout .js-form-type-textfield.form-street-number,
    .mt-checkout .js-form-type-textfield.form-apartment-number,
    .mt-checkout .js-form-type-textfield.form-postal,
    .mt-checkout .js-form-type-textfield.form-nip {
      width: 30%;
    }

    .mt-checkout .js-form-type-textfield.form-street {
      width: 40%;
    }

    .mt-checkout .js-form-type-textfield.form-email,
    .mt-checkout .js-form-type-textfield.form-city {
      width: 70%;
    }

    .mt-checkout .js-form-type-textfield.form-coname {
        width: 100%;
    }
  }

  .mt-checkout .js-form-type-textfield input, .mt-checkout .js-form-type-textfield textarea {
    height: 70px;
    outline: 0;
    background: #fafafa;
    border: 0;
    border-radius: 0;
    margin: 0 0 25px;
    padding: 25px;
    box-sizing: border-box;
    font-size: 14px;
  }

  .mt-checkout .js-form-type-textfield textarea {
    height: 140px;
  }

  .mt-checkout .js-form-type-textfield input:focus, .mt-checkout .js-form-type-textfield textarea:focus {
    border-radius: 0;
  }

  .mt-checkout .js-form-type-textfield label {
    position: absolute;
    font-size: 14px;
    padding: 25px;
    color: #a1a1a1;
  }

  .invalid-form {
    border-color: red !important;
    border-width: 1px !important;
    border-style: solid !important;
  }

  .form-check {
    padding-left: 0;
  }

  /* hide the regular checkbox */
  .pd-checkbox input {
    opacity: 0;
    position: absolute;
  }
  /* position the label */
  .pd-checkbox input, .pd-checkbox label {
    display: inline-block;
    vertical-align: middle;
    margin: 5px;
    cursor: pointer;
  }

  .pd-checkbox label {
    position: relative;
  }
  /* style the unchecked checkbox */
  .pd-checkbox input + label:before {
    content: '';
    background: #fff;
    border: 2px solid #ddd;
    display: inline-block;
    vertical-align: middle;
    width: 18px;
    height:18px;
    margin-right: 10px;
    text-align: center;
    font-size:15px;
    line-height:15px;
  }
  /* style the checked checkbox */
  .pd-checkbox input:checked + label:before {
    background-image: url("/assets/mt-white-check.png");
    background-color: #4092e5;
    background-repeat: no-repeat;
    border-color:#295d92;
    background-size: 12px 11px;
    background-position: center;
  }

  .invalid {
    background-color: #ffd2d2 !important;
  }

  .error {
    display: none;
  }
  /* ------------------ END - forms ------------------ */

  /* ------------------ START - nprogress ------------------ */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: #29d;

    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }

  /* Fancy blur effect */
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    opacity: 1.0;
  }

  /* Remove these to get rid of the spinner */
  #nprogress .spinner {
    display: block;
    position: fixed;
    z-index: 1031;
    top: 30px;
    right: 15px;
  }

  #nprogress .spinner-icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;

    border: solid 2px transparent;
    border-top-color: #29d;
    border-left-color: #29d;
    border-radius: 50%;

    -webkit-animation: nprogress-spinner 400ms linear infinite;
    animation: nprogress-spinner 400ms linear infinite;
  }

  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;
  }

  .nprogress-custom-parent #nprogress .spinner,
  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }

  @-webkit-keyframes nprogress-spinner {
    0%   { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  @keyframes nprogress-spinner {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  /* ------------------ END - nprogress ------------------ */

  /* ------------------ START - vanillatoasts ------------------ */
  .vanillatoasts-icon {
    display: none !important;
  }

  #vanillatoasts-container {
    top: 65px !important;
  }

  .vanillatoasts-toast {
    background: #4092e5 !important;
    border-radius: 2px !important;
    color: white;
  }
  /* ------------------ END - vanillatoasts ------------------ */
</style>

